import { Icon, Tooltip } from '@billy/design-system'

import * as Styled from './styles'

interface DisabledItemWithTooltipProps {
  label: string
  tooltipLabel: string
}

export const DisabledItemWithTooltip = ({ label, tooltipLabel }: DisabledItemWithTooltipProps) => {
  return (
    <Styled.DisabledItemWithTooltipWrapper>
      <Tooltip placement="bottom" label={tooltipLabel}>
        <Styled.DisabledItemWithTooltipContent>
          <div>{label}</div>
          <Icon icon="info" />
        </Styled.DisabledItemWithTooltipContent>
      </Tooltip>
    </Styled.DisabledItemWithTooltipWrapper>
  )
}
